import {
  Box,
  IconButton,
  Table,
  Tag,
  Text,
  Title,
} from '@nimbus-ds/components';
import { Repeater, Stack } from 'commons/components';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import PartnersListDesktopHeader from '../PartnersListDesktopHeader';

function PartnersListDesktopItemSkeleton(index) {
  return (
    <Table.Row key={index}>
      <Table.Cell>
        <Text.Skeleton width="50px" />
      </Table.Cell>
      <Table.Cell>
        <Text.Skeleton width="100px" />
      </Table.Cell>
      <Table.Cell>
        <Tag.Skeleton width="60px" height="1rem" />
      </Table.Cell>
      <Table.Cell>
        <Box width="fit-content">
          <Stack spacing="tight">
            <IconButton.Skeleton height="2rem" width="2rem" />
          </Stack>
        </Box>
      </Table.Cell>
    </Table.Row>
  );
}

function PartnersListDesktopSkeleton() {
  const t = useTranslationConfigurations('partnersListComponent');
  return (
    <Box flexDirection="column" gap="2" display="flex">
      <Title as="h4">{t('title')}</Title>
      <Table>
        <PartnersListDesktopHeader />
        <Table.Body>
          <Repeater times={1} item={PartnersListDesktopItemSkeleton} />
        </Table.Body>
      </Table>
    </Box>
  );
}

export default PartnersListDesktopSkeleton;
